<template>
    <div class="user-pin-settings border-top pt-3 mt-2">
        <div v-if="!panelVisible">
            <button type="button" class="btn btn-link btn-sm text-decoration-none p-0" @click="openUnlock">
                Gerenciar PIN
            </button>
            <span class="text-muted small ms-2">Troca periódica do PIN de identificação</span>
        </div>

        <auth-pin
            ref="authPin"
            modal-id="user-profile-pin-modal"
            modal-title="Informe seu PIN atual"
            :post-unlock-url="unlockUrl"
            :expected-user-id="userId"
            @validated="onPanelUnlocked"
        />

        <div v-if="panelVisible" class="card mt-2 border-secondary">
            <div class="card-body py-3">
                <p class="text-muted small mb-3 mb-md-2">
                    Cada clique em «Gerar novo PIN» já grava no sistema. Você pode gerar várias vezes até anotar um número adequado.
                    Não é necessário salvar o formulário de Meus dados.
                </p>
                <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
                    <button type="button" class="btn btn-primary btn-sm" :disabled="swapLoading" @click="swapPin">
                        Gerar novo PIN
                    </button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" :disabled="swapLoading" @click="hidePanel">
                        Ocultar
                    </button>
                </div>
                <div v-if="lastPin" class="fs-4 font-monospace user-select-all">{{ lastPin }}</div>
                <div v-else class="text-muted small">Clique em «Gerar novo PIN» para exibir um número.</div>
            </div>
        </div>
    </div>
</template>

<script>
function csrfHeader() {
    const el = document.querySelector('meta[name="csrf-token"]');
    const token = el ? el.getAttribute('content') : '';
    return token ? { 'X-CSRF-TOKEN': token } : {};
}

export default {
    props: {
        userId: {
            type: Number,
            required: true,
        },
        unlockUrl: {
            type: String,
            required: true,
        },
        swapUrl: {
            type: String,
            required: true,
        },
        lockUrl: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            panelVisible: false,
            lastPin: '',
            swapLoading: false,
        };
    },

    methods: {
        openUnlock() {
            this.$refs.authPin.openModal();
        },

        onPanelUnlocked() {
            this.panelVisible = true;
            this.lastPin = '';
        },

        swapPin() {
            this.swapLoading = true;
            axios
                .post(this.swapUrl, {}, { headers: csrfHeader() })
                .then((res) => {
                    if (res.data && res.data.pin) {
                        this.lastPin = res.data.pin;
                    }
                })
                .catch((err) => {
                    const msg = err.response && err.response.data && err.response.data.message
                        ? err.response.data.message
                        : 'Não foi possível gerar o PIN.';
                    if (typeof window.ajaxSetMessage === 'function') {
                        window.ajaxSetMessage('error', msg);
                    } else {
                        alert(msg);
                    }
                    if (err.response && err.response.status === 403) {
                        this.panelVisible = false;
                        this.lastPin = '';
                    }
                })
                .finally(() => {
                    this.swapLoading = false;
                });
        },

        hidePanel() {
            axios
                .post(this.lockUrl, {}, { headers: csrfHeader() })
                .finally(() => {
                    this.panelVisible = false;
                    this.lastPin = '';
                });
        },
    },
};
</script>
